import {align, text} from './text.fields';
import {box, height, margin, width} from './box.fields';
import {imageField} from './image.fields';
import {backgroundColor} from './background.fields';
import {shadow} from './shadow.fields';

export const showImage = {
  name: 'showImage',
  label: 'Image',
  component: 'radio-group',
  variant: 'button',
  options: [{value: 'true', label: 'Yes'}, {value: 'false', label: 'Not'}],
};


export const imageSettings = {
  name: 'media',
  label: 'Imagen Settings',
  component: 'group',
  fields: [
    showImage,
    {
      name: '',
      label: 'Imagen',
      component: 'condition-group',
      condition: (value) => value?.showImage === 'true'
      ,
      fields: [
        ...imageField,
        {
          name: 'position',
          label: 'Image Position',
          component: 'radio-group',
          variant: 'button',
          options: ['left', 'top', 'right'],
        },
        {
          name: 'box',
          label: '',
          component: 'responsive-group',
          fields: [
            {
              ...width,
              name: 'size.width'
            }, {
              ...height,
              name: 'size.height'
            },
            margin
          ]
        },
        align
      ]
    }
  ]
};


export const featureFields = [
  {
    name: 'titleProps',
    label: 'Title',
    component: 'group',
    fields: [
      text,
      box,
    ]
  },
  {
    name: 'secondaryProps',
    label: 'Secondary Text',
    component: 'group',
    fields: [
      text,
      box,
    ]
  },
  {
    ...backgroundColor,
    name: 'background.backgroundColor'
  },
  imageSettings,
  shadow,
  box,
];
